import log from '../../lib/salvo-lite/log'
import HandyCollapse from 'handy-collapse'

class AccordionV2 {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._data = {
            animationSpeed: 300,
            cssEasing: escape,
            ...JSON.parse(elem.getAttribute('data-accordion-v2'))
        }

        this._accordion = new HandyCollapse(this._data)
    }

    onInit () {
        log.debug(this.constructor.name, 'Constructed', this)
    }
}

export default AccordionV2



// WEBPACK FOOTER //
// ./resources/scripts/components/AccordionV2.js